import React from 'react'
import { useStableUsRestrictedDataAccess } from 'enrollment-platform/rbac/useStableUsRestrictedDataAccess'
import ApplicationDetailRestricted from 'routes/ApplicationManager/routes/ApplicationDetail/components/ApplicationDetailRestricted'

/**
 * Hides an application-queue surface from callers without
 * UsRestrictedData:Manage. Children stay unmounted, so their reads never run.
 * The shared application-engine API stays open for Application Engine.
 */
export function ApplicationQueueUsRestrictedGate({
  children,
}: {
  children: React.ReactNode
}) {
  const { hasUsRestrictedDataAccess, isLoading } =
    useStableUsRestrictedDataAccess()

  if (isLoading) return null
  if (!hasUsRestrictedDataAccess) return <ApplicationDetailRestricted />
  return <>{children}</>
}
